import { Action, ActionReducer } from '@ngrx/store';
import { merge, pick } from 'lodash-es';

import { SESSION_STORAGE } from '../../shared/constants/storage.constants';
import { readJsonFromSessionStorage } from '../../shared/utils/session-storage.utils';

const stateKeysToStoreLocally = ['osm', 'core.loggedIn', 'core.levelOfTrust'];

export function storageMetaReducer<S, A extends Action = Action>(reducer: ActionReducer<S, A>) {
    let isFirstTimeAfterLoadRefresh = true;
    return (state: S, action: A) => {
        const nextState = reducer(state, action);
        if (isFirstTimeAfterLoadRefresh) {
            isFirstTimeAfterLoadRefresh = false;
            const savedState = readFromSessionStorage();
            return merge(nextState, savedState);
        }
        const stateToSave = pick(nextState, stateKeysToStoreLocally);
        const osmFromStore = readFromSessionStorage()?.osm;
        if (!stateToSave.osm && osmFromStore) {
            stateToSave.osm = osmFromStore; // we might loose it otherwise
        }
        saveToSessionStorage(stateToSave);
        return nextState;
    };
}

function saveToSessionStorage(state: any) {
    if (Object.keys(state).length) {
        sessionStorage.setItem(SESSION_STORAGE.NGRX_STORE_OSM.key, JSON.stringify(state));
    }
}

function readFromSessionStorage(): any {
    return readJsonFromSessionStorage(SESSION_STORAGE.NGRX_STORE_OSM.key);
}
